import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

import { getCargo } from '../../../slices/portCallSlice';

import Page from '../../../../layout/components/Page';
import ProgressBar from '../../../../layout/components/ProgressBar';

const Cargo = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const [percentage, setPercentage] = useState('50');
  const [pageNumber, setPageNumber] = useState('');

  useEffect(() => {
    dispatch(getCargo(params.uid));
  }, [dispatch, params.uid]);

  useEffect(() => {
    if (location.pathname === `/${params.uid}/cargo/information`) {
      setPercentage('50');
      setPageNumber('1');
    } else if (location.pathname === `/${params.uid}/cargo/documents`) {
      setPercentage('100');
      setPageNumber('2');
    }
  }, [location.pathname, params.uid]);

  if (location.pathname === `/${params.uid}/cargo`) {
    return <Navigate to={`/${params.uid}/cargo/information`} replace />;
  }

  return (
    <Page>
      <div className="cargo">
        <ProgressBar
          percentage={percentage}
          pageNumber={pageNumber}
          totalPages={'2'}
        />
        <Outlet />
      </div>
    </Page>
  );

  // return (
  //   <Page>
  //     <div className='cargo'>
  //       <CargoInformation />
  //     </div>
  //   </Page>
  // );
};

export default Cargo;
